import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  TextField,
} from "@mui/material";
import { Select, ListItemText, Checkbox } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import SaveIcon from "@mui/icons-material/Save";
import { InputLabel } from "@mui/material";
import { useSelector } from "react-redux";
import CheckIcon from "@mui/icons-material/Check";

const OperationsForm = ({
  handleSave,
  handleChange,
  formData,
  errors,
  hasChanges,
}) => {
  const { vendorProfileDetails } = useSelector((state) => state.vendorProfile);

  return (
    <Box p={2}>
      <Card variant="outlined" sx={{ borderRadius: 5 }}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Operational Details
            </Typography>
            {hasChanges && (
              <Button
                onClick={handleSave}
                startIcon={<SaveIcon />}
                variant="contained"
                color="primary"
              >
                Save
              </Button>
            )}
          </Box>
          <Box sx={{ overflowY: "scroll", maxHeight: "48vh" }}>
            <Grid container spacing={3}>
              {/* type of business */}
              <Grid item xs={12} md={6}>
                <InputLabel
                  sx={{
                    color: errors?.typeOfBusiness
                      ? "var(--error-color)"
                      : "inherit",
                    fontWeight: 600, // example of additional style
                  }}
                >
                  Type of Business *
                </InputLabel>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{ marginTop: "0.5rem" }}
                  error={!!errors.typeOfBusiness}
                  errorMessage={
                    errors.typeOfBusiness ? (
                      <span style={{ color: "var(--error-color)" }}>
                        Please Select type of business
                      </span>
                    ) : null
                  }
                  value={formData?.typeOfBusiness}
                >
                  <Select
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Set border color
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on focus
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on hover
                      },
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": {
                          borderColor: "#b0b0b0", // Ensure hover state is consistent
                        },
                      },
                    }}
                    style={{ color: formData.typeOfBusiness ? "" : "#a2a2a2" }}
                    displayEmpty
                    name="typeOfBusiness"
                    value={formData?.typeOfBusiness}
                    onChange={handleChange}
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <p className="text-[1rem] text-[var(--light-gray)]">
                            Type of Business
                          </p>
                        );
                      }

                      return selected;
                    }}
                  >
                    <MenuItem
                      value="One Person Company"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      One Person Company
                      {formData?.typeOfBusiness === "One Person Company" && (
                        <CheckIcon sx={{ color: "#418cff" }} />
                      )}
                    </MenuItem>

                    <MenuItem
                      value="Sole Proprietor"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      Sole Proprietor
                      {formData?.typeOfBusiness === "Sole Proprietor" && (
                        <CheckIcon sx={{ color: "#418cff" }} />
                      )}
                    </MenuItem>

                    <MenuItem
                      value="Partnership"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      Partnership
                      {formData?.typeOfBusiness === "Partnership" && (
                        <CheckIcon sx={{ color: "#418cff" }} />
                      )}
                    </MenuItem>

                    <MenuItem
                      value="Foreign Company"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      Foreign Company
                      {formData?.typeOfBusiness === "Foreign Company" && (
                        <CheckIcon sx={{ color: "#418cff" }} />
                      )}
                    </MenuItem>

                    <MenuItem
                      value="LLP"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      LLP
                      {formData?.typeOfBusiness === "LLP" && (
                        <CheckIcon sx={{ color: "#418cff" }} />
                      )}
                    </MenuItem>

                    <MenuItem
                      value="Private Limited Company"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      Private Limited Company
                      {formData?.typeOfBusiness ===
                        "Private Limited Company" && (
                        <CheckIcon sx={{ color: "#418cff" }} />
                      )}
                    </MenuItem>

                    <MenuItem
                      value="Limited Company"
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      Limited Company
                      {formData?.typeOfBusiness === "Limited Company" && (
                        <CheckIcon sx={{ color: "#418cff" }} />
                      )}
                    </MenuItem>
                  </Select>
                </FormControl>
                {errors.typeOfBusiness && (
                  <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                    {errors.typeOfBusiness}
                  </p>
                )}
              </Grid>
              {/* turnover */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.avgTurnoverLast3Years ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  Turnover (Average 3 years) *
                </Typography>

                <TextField
                  fullWidth
                  name="avgTurnoverLast3Years"
                  value={formData?.avgTurnoverLast3Years || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors?.avgTurnoverLast3Years}
                  helperText={errors?.avgTurnoverLast3Years}
                />
              </Grid>
              {/* Esic/ pf */}
              <Grid item xs={12} md={6}>
                <InputLabel
                  sx={{
                    color: errors?.registeredInESIPF
                      ? "var(--error-color)"
                      : "inherit",
                    fontWeight: 600, // example of additional style
                  }}
                >
                  Registered in ESI/PF *
                </InputLabel>

                <FormControl
                  fullWidth
                  size="small"
                  sx={{ marginTop: "0.5rem" }}
                  error={errors.registeredInESIPF}
                  errorMessage={errors.registeredInESIPF}
                  value={formData?.registeredInESIPF}
                >
                  <Select
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Set border color
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on focus
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on hover
                      },
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": {
                          borderColor: "#b0b0b0", // Ensure hover state is consistent
                        },
                      },
                    }}
                    style={{
                      color: formData.registeredInESIPF ? "" : "#a2a2a2",
                    }}
                    displayEmpty
                    name="registeredInESIPF"
                    value={formData?.registeredInESIPF}
                    onChange={handleChange}
                    renderValue={(selected) =>
                      selected === true
                        ? "Yes"
                        : selected === false
                        ? "No"
                        : "Select"
                    }
                  >
                    <MenuItem value={true}>
                      Yes
                      {formData?.registeredInESIPF === true && (
                        <CheckIcon
                          sx={{ marginLeft: "auto", color: "#418cff" }}
                        />
                      )}
                    </MenuItem>
                    <MenuItem value={false}>
                      No
                      {formData?.registeredInESIPF === false && (
                        <CheckIcon
                          sx={{ marginLeft: "auto", color: "#418cff" }}
                        />
                      )}
                    </MenuItem>
                  </Select>
                </FormControl>
                {errors.registeredInESIPF && (
                  <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                    {errors.registeredInESIPF}
                  </p>
                )}
              </Grid>
              {/* production area */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.productionArea ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  Production Are (Sq. Ft.) *
                </Typography>

                <TextField
                  fullWidth
                  name="productionArea"
                  value={formData?.productionArea || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors?.productionArea}
                  helperText={errors?.productionArea}
                />
              </Grid>
              {/* number of employees */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.numberOfEmployees ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  No. of Employess *
                </Typography>

                <TextField
                  fullWidth
                  name="numberOfEmployees"
                  value={formData?.numberOfEmployees || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors?.numberOfEmployees}
                  helperText={errors?.numberOfEmployees}
                />
              </Grid>
              {/* number of skilled employee */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.numberOfSkilledManpower
                      ? "#d32f2f"
                      : "inherit",
                  }}
                  gutterBottom
                >
                  Number of Skilled Manpower *
                </Typography>

                <TextField
                  fullWidth
                  name="numberOfSkilledManpower"
                  value={formData?.numberOfSkilledManpower || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors?.numberOfSkilledManpower}
                  helperText={errors?.numberOfSkilledManpower}
                />
              </Grid>
              {/* number of unskilled manpower */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.numberOfUnskilledManpower
                      ? "#d32f2f"
                      : "inherit",
                  }}
                  gutterBottom
                >
                  Number of Unskilled Manpower *
                </Typography>

                <TextField
                  fullWidth
                  name="numberOfUnskilledManpower"
                  value={formData?.numberOfUnskilledManpower || ""}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                  error={!!errors?.numberOfUnskilledManpower}
                  helperText={errors?.numberOfUnskilledManpower}
                />
              </Grid>
              {/* factors help in scale */}
              <Grid item xs={12} md={6}>
                <InputLabel
                  sx={{
                    color: errors?.scalingFactors
                      ? "var(--error-color)"
                      : "inherit",
                    fontWeight: 600, // example of additional style
                  }}
                >
                  Factors that will help you scale *
                </InputLabel>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{ marginTop: "0.25rem" }}
                  error={errors.scalingFactors}
                  // errorMessage={
                  //   errors.scalingFactors ? (
                  //     <span style={{ color: "var(--error-color)" }}>
                  //       Please Select type of business
                  //     </span>
                  //   ) : null
                  // }
                  value={formData?.scalingFactors}
                >
                  <Select
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Set border color
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on focus
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0", // Keep border color on hover
                      },
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": {
                          borderColor: "#b0b0b0", // Ensure hover state is consistent
                        },
                      },
                    }}
                    style={{ color: formData.scalingFactors ? "" : "#a2a2a2" }}
                    displayEmpty
                    name="scalingFactors"
                    value={formData?.scalingFactors}
                    onChange={handleChange}
                    multiple={true}
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return (
                          <p className="text-[1rem] text-[#a2a2a2]">
                            Choose Scaling Factors
                          </p>
                        );
                      }

                      return selected.join(",");
                    }}
                  >
                    <MenuItem value="Skilled manpower">
                      <Checkbox
                        checked={formData?.scalingFactors.includes(
                          "Skilled manpower"
                        )}
                      />
                      <ListItemText primary="Skilled manpower" />
                    </MenuItem>
                    <MenuItem value="Capital">
                      <Checkbox
                        checked={formData?.scalingFactors.includes("Capital")}
                      />
                      <ListItemText primary="Capital" />
                    </MenuItem>
                    <MenuItem value="Marketing">
                      <Checkbox
                        checked={formData?.scalingFactors.includes("Marketing")}
                      />
                      <ListItemText primary="Marketing" />
                    </MenuItem>
                    <MenuItem value="Mfg. Capability">
                      <Checkbox
                        checked={formData?.scalingFactors.includes(
                          "Mfg. Capability"
                        )}
                      />
                      <ListItemText primary="Mfg. Capability" />
                    </MenuItem>
                    <MenuItem value="Machinery">
                      <Checkbox
                        checked={formData?.scalingFactors.includes("Machinery")}
                      />
                      <ListItemText primary="Machinery" />
                    </MenuItem>
                    <MenuItem value="Personal Factors">
                      <Checkbox
                        checked={formData?.scalingFactors.includes(
                          "Personal Factors"
                        )}
                      />
                      <ListItemText primary="Personal Factors" />
                    </MenuItem>
                  </Select>
                </FormControl>
                {errors.scalingFactors && (
                  <p className="font-normal text-[0.75rem] leading-[1.66] tracking-[0.03em] text-left mt-[4px] mr-[14px] mb-0 ml-[14px] text-[var(--error-color)]">
                    {errors.scalingFactors}
                  </p>
                )}
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OperationsForm;
